import React from 'react';
import { ContractType } from '@/newcar/util/const/contract';
import { scrollToId } from '@/newcar/ui/contract/function';
import * as styl from './index.module.styl';

interface AlertButtonProps {
  errors: string[];
  type: ContractType;
}

const gtmNameList: { [ContactKey in ContractType]: string } = {
  contact_info: 'contactInfo',
  personal_info: 'personalInfo',
  review_info: 'reviewInfo',
  provisional_completion: '',
};

// 申込みフォームの画面上部のエラー表示
export default function AlertButton(props: AlertButtonProps): JSX.Element {
  const {
    errors,
    type,
  } = props;

  const message = () => `未入力の項目が${errors.length}件あります。`;

  const handleButtonClick = () => {
    // 遷移先のエレメントを取得（セクションのタイトル部分）
    // 複数エラーIDがある場合、遷移先は先頭とする
    scrollToId(`form-section-${errors[0]}`);
  };

  return (
    <div className={styl.validationAlertWrap}>
      <button
        id="ab-validation-alert-wrap-button"
        data-gtm={`gtm-newcarform-${gtmNameList[type]}-errorJumpBtn`}
        className={`is-size-4 ${styl.validationAlert}`}
        type="button"
        onClick={handleButtonClick}
      >
        {message()}
      </button>
    </div>
  );
}
